import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CommunitySelectDialog = ({ open, onClose, communities, onCommunitySelect }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('login.chooseCommunity')}</DialogTitle>
      <DialogContent>
        {communities.map((community) => (
          <Box
            key={community.id}
            onClick={() => onCommunitySelect(community)}
            sx={{
              padding: 1,
              margin: 1,
              textAlign: "center",
              cursor: "pointer",
              bgcolor: "background.default",
              "&:hover": {
                bgcolor: "action.hover",
              },
            }}
          >
            {community.name}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommunitySelectDialog; 